import React from 'react';
import { Button } from 'react-bootstrap';
import { useInView } from 'react-intersection-observer';

import "../../css/Ubicacion.css";
import "../../css/Fondo.css";

const Ubicacion = ({ theme = 'ltm' }) => {
    const { ref: tituloRef, inView: tituloInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: mapaRef, inView: mapaInView } = useInView({ threshold: 0.1, triggerOnce: true });
    const { ref: textoRef, inView: textoInView } = useInView({ threshold: 0.1, triggerOnce: true });

    const scrollToSection = (id) => {
        const section = document.querySelector(id);
        if (section) {
            const navbar = document.querySelector('.navbar');
            const offset = navbar ? navbar.offsetHeight : 0;
            const sectionPosition = section.offsetTop - offset;

            window.scrollTo({
                top: sectionPosition,
                behavior: 'smooth',
            });
        }
    };

    return (
        <div id="ubicacion" className={`${theme}-fondo-rojo py-4`}>
            <div className={`${theme}-ubicacion-main-div`}>
                <h1
                    ref={tituloRef}
                    className={`${theme}-titulo-ubicacion text-center pt-4 mx-5 ubicacion-transition-element ${tituloInView ? 'ubicacion-animate-in-bottom' : ''
                        }`}
                >
                    UBICACIÓN
                </h1>

                <h2
                    className={`text-center ubicacion-transition-element ${tituloInView ? 'ubicacion-animate-in-bottom ubicacion-delay-1' : ''
                        }`}
                >
                    ESTAMOS CERCA
                </h2>

                <div
                    className={`text-center ubicacion-transition-element ${tituloInView ? 'ubicacion-animate-in-bottom ubicacion-delay-2' : ''
                        }`}
                >
                    <Button className={`${theme}-btn-ubicacion-outline-light ${theme}-btn-ubicacion btn-lg`} onClick={() => scrollToSection('#mapaUbicacion')}>
                        ¿CÓMO LLEGAR?
                    </Button>
                </div>

                <div id="mapaUbicacion" className='text-center my-2'>
                    <i className="bi bi-arrow-down fs-1"></i>
                </div>

                <div
                    ref={mapaRef}
                    className={`containerMap mb-3 ubicacion-transition-element ${mapaInView ? 'ubicacion-animate-in-scale' : ''}`}
                >
                    <div className="ratio custom-map-ratio">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1100.577504738126!2d-62.26328147152852!3d-38.72002981544128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95edbcb3351804bf%3A0xaf30e1f42bcb2984!2sBingo%20Bah%C3%ADa!5e0!3m2!1ses!2sar!4v1745583844692!5m2!1ses!2sar"
                            width="100%"
                            height="200"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Ubicación Bingo Bahía en Google Maps"
                        >
                        </iframe>
                    </div>
                </div>

                <h3
                    ref={textoRef}
                    className={`text-center pt-2 px-2 ubicacion-transition-element ${textoInView ? 'ubicacion-animate-in-bottom ubicacion-delay-1' : ''
                        }`}
                >
                    Vení al Bingo: <strong>Chiclana 250, Belgrano 39, Bahía Blanca.</strong>
                </h3>
            </div>
        </div>
    );
};

export default Ubicacion;
